<script setup>
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import KnowledgebaseCard from './KnowledgebaseCard.vue';
import { computed } from 'vue';

const props = defineProps({
  knowledgebases: {
    type: Array,
    default: () => [],
  },
  showEmptyResult: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select', 'edit', 'delete']);

const groupedKnowledgebases = computed(() => {
  const grouped = {};
  props.knowledgebases.forEach(kb => {
    if (kb.parent_id) {
      if (!grouped[kb.parent_id]) {
        grouped[kb.parent_id] = [];
      }
      grouped[kb.parent_id].push(kb);
    } else if (!grouped[kb.id]) {
      grouped[kb.id] = [];
    }
  });
  return grouped;
});

const findKnowledgebaseById = id =>
  props.knowledgebases.find(kb => kb.id === id);
</script>

<template>
  <div class="flex items-center flex-col">
    <div v-if="isLoading" class="items-center flex text-base justify-center">
      <Spinner color-scheme="primary" />
      <span>{{ $t('LIBRARIES.RECORDS.LOADING_MESSAGE') }}</span>
    </div>
    <div v-else class="w-full">
      <EmptyState v-if="showEmptyResult" :title="$t('LIBRARIES.404')" />
      <div v-else class="w-full flex flex-row gap-4 items-center flex-wrap">
        <table class="w-full woot-table">
          <thead class="border-b border-neutral-100 text-sm">
            <tr>
              <th>
                {{ $t('LIBRARIES.OVERVIEW.NAME') }}
              </th>
              <th>
                {{ $t('LIBRARIES.OVERVIEW.DESCRIPTION') }}
              </th>
              <td />
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(children, parentId) in groupedKnowledgebases"
              :key="parentId"
            >
              <tr>
                <KnowledgebaseCard
                  v-if="
                    findKnowledgebaseById(Number(parentId)) &&
                    findKnowledgebaseById(Number(parentId)).parent_id == null
                  "
                  :key="parentId"
                  :knowledgebase="findKnowledgebaseById(Number(parentId))"
                  @select="knowledgebase => emit('select', knowledgebase)"
                  @edit="knowledgebase => emit('edit', knowledgebase)"
                  @delete="knowledgebase => emit('delete', knowledgebase)"
                />
              </tr>
              <tr v-for="child in children" :key="child.id" class="nested-row">
                <KnowledgebaseCard
                  :knowledgebase="child"
                  @select="knowledgebase => emit('select', knowledgebase)"
                  @edit="knowledgebase => emit('edit', knowledgebase)"
                  @delete="knowledgebase => emit('delete', knowledgebase)"
                />
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
